import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_get_serialnumbers_by_licensePlateIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licensePlateIds: number[] }): 
  Promise<{ result: { Id?: number, ChainHead?: number, OriginalChainHead?: number, OutboundShipmentId?: number, TasksForSerialNumber?: { Id?: number, ActualSourceLicensePlateId?: number, ShipmentId?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licensePlateIds)) {
      missingRequiredInParams.push('\'licensePlateIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_serialnumbers_by_licensePlateIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { licensePlateIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ChainHead?: number, OriginalChainHead?: number, OutboundShipmentId?: number, TasksForSerialNumber?: { Id?: number, ActualSourceLicensePlateId?: number, ShipmentId?: number }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licensePlateIds)) {
      missingRequiredInParams.push('\'licensePlateIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_serialnumbers_by_licensePlateIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { licensePlateIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ChainHead?: number, OriginalChainHead?: number, OutboundShipmentId?: number, TasksForSerialNumber?: { Id?: number, ActualSourceLicensePlateId?: number, ShipmentId?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licensePlateIds)) {
      missingRequiredInParams.push('\'licensePlateIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_serialnumbers_by_licensePlateIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      licensePlateIds: number[]    }) {
        if(isNil(inParams.licensePlateIds)) {
          return true; 
        }
      return false;
    }
}
